export default function (other) {
  other = other || {}
  return {
    firstName: other.firstName,
    lastName: other.lastName,
    email: other.email,
    phone: other.phone,
    username: other.username,
    code: other.code,
    orgIds: other.orgIds,
    roleId: other.roleId,
    businessUnitIds: other.businessUnitIds,
    search: other.search,
    // USER_ACTIONS holders: also list soft-hidden users
    showHidden: other.showHidden === true ? true : null,
    pagination: other.pagination,
    sort: other.sort,
  }
}
